import React from 'react';

interface VotingCardProps {
  value: string;
  isSelected: boolean;
  onClick: (value: string) => void;
  disabled?: boolean;
}

const VotingCard: React.FC<VotingCardProps> = ({ value, isSelected, onClick, disabled = false }) => {
  return (
    <div
      className={`vote-card ${isSelected ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
      data-value={value}
      onClick={() => !disabled && onClick(value)}
    >
      {value}
    </div>
  );
};

export default VotingCard;